import { createReducer } from '@reduxjs/toolkit'

import { TCustomField } from 'types/GlobalCustomField'

import * as actions from '../../actions/CustomFields/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface CustomFieldReducerType {
  data: TCustomField[]
  fetching: boolean
  fetched: boolean
}

const INITIAL_STATE: CustomFieldReducerType = {
  data: [],
  fetching: false,
  fetched: false
}

const customFieldReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetching = true
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = action.payload
      state.fetching = false
      state.fetched = true
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetching = false
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.data.push(action.payload)
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default customFieldReducer
